import { createApp } from 'vue'
import 'bootstrap/dist/css/bootstrap.css'
import App from './App.vue'
import appAxios from './axios/appAxios'
import router from '@/router';
import store from './store';
import './assets/datatables/datatables.bundle.css';
import i18n from './i18n.js'
const app=createApp(App)
app.use(router)
app.use(store)
app.use(i18n);
app.config.globalProperties.$appAxios = appAxios;
app.mount("#app");